// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__3Y1VQ","title":"AfterImages90_title__3_8a_","images":"AfterImages90_images__2_iUw"};